/* tslint:disable */
/**
* Kronos Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { LatestMessageRequestDto } from '../model/latestMessageRequestDto';
import { LatestMessageResponseDto } from '../model/latestMessageResponseDto';
import { UploadPolicy } from '../model/uploadPolicy';
import { ZulipChannelDto } from '../model/zulipChannelDto';
import { ZulipCredentialsDto } from '../model/zulipCredentialsDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ZulipService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param fileName 
     * @param folderName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ensureAttachmentHeader(fileName: string, folderName: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public ensureAttachmentHeader(fileName: string, folderName: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public ensureAttachmentHeader(fileName: string, folderName: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public ensureAttachmentHeader(fileName: string, folderName: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (fileName === null || fileName === undefined) {
            throw new Error('Required parameter fileName was null or undefined when calling ensureAttachmentHeader.');
        }
        if (folderName === null || folderName === undefined) {
            throw new Error('Required parameter folderName was null or undefined when calling ensureAttachmentHeader.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/zulip/${encodeURIComponent(String(fileName))}/${encodeURIComponent(String(folderName))}/ensureAttachmentHeader`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public favorite(workspaceId: string, name: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public favorite(workspaceId: string, name: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public favorite(workspaceId: string, name: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public favorite(workspaceId: string, name: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling favorite.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling favorite.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/zulip/${encodeURIComponent(String(workspaceId))}/${encodeURIComponent(String(name))}/favorite`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param zulipIds 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChannelsByZulipIds(zulipIds?: Array<number>, observe?: 'body', reportProgress?: boolean): Promise<Array<ZulipChannelDto>>;
    public getChannelsByZulipIds(zulipIds?: Array<number>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<ZulipChannelDto>>>;
    public getChannelsByZulipIds(zulipIds?: Array<number>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<ZulipChannelDto>>>;
    public getChannelsByZulipIds(zulipIds?: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (zulipIds) {
            zulipIds.forEach((element) => {
                queryParameters = queryParameters.append('zulipIds', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/zulip/channels`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFavorites(observe?: 'body', reportProgress?: boolean): Promise<Array<ZulipChannelDto>>;
    public getFavorites(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<ZulipChannelDto>>>;
    public getFavorites(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<ZulipChannelDto>>>;
    public getFavorites(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/zulip/favorites`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLatestMessages(body?: Array<LatestMessageRequestDto>, observe?: 'body', reportProgress?: boolean): Promise<Array<LatestMessageResponseDto>>;
    public getLatestMessages(body?: Array<LatestMessageRequestDto>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<LatestMessageResponseDto>>>;
    public getLatestMessages(body?: Array<LatestMessageRequestDto>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<LatestMessageResponseDto>>>;
    public getLatestMessages(body?: Array<LatestMessageRequestDto>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/zulip/channels/latestMessages`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param path 
     * @param token 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadedImagePath(path?: string, token?: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public getUploadedImagePath(path?: string, token?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public getUploadedImagePath(path?: string, token?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public getUploadedImagePath(path?: string, token?: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (path !== undefined && path !== null) {
            queryParameters = queryParameters.set('path', <any>path);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/zulip/uploads`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getZulipCredentialsForCurrentUser(observe?: 'body', reportProgress?: boolean): Promise<ZulipCredentialsDto>;
    public getZulipCredentialsForCurrentUser(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<ZulipCredentialsDto>>;
    public getZulipCredentialsForCurrentUser(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<ZulipCredentialsDto>>;
    public getZulipCredentialsForCurrentUser(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/zulip/current-user-password`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshZulipCredentialsForCurrentUser(observe?: 'body', reportProgress?: boolean): Promise<ZulipCredentialsDto>;
    public refreshZulipCredentialsForCurrentUser(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<ZulipCredentialsDto>>;
    public refreshZulipCredentialsForCurrentUser(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<ZulipCredentialsDto>>;
    public refreshZulipCredentialsForCurrentUser(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/zulip/current-user-password/refresh`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resolveChannelsByZulipIds(body?: Array<number>, observe?: 'body', reportProgress?: boolean): Promise<Array<ZulipChannelDto>>;
    public resolveChannelsByZulipIds(body?: Array<number>, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<Array<ZulipChannelDto>>>;
    public resolveChannelsByZulipIds(body?: Array<number>, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<Array<ZulipChannelDto>>>;
    public resolveChannelsByZulipIds(body?: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/zulip/channels/byZulipIds`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public spawnChannel(workspaceId: string, channelId: string, observe?: 'body', reportProgress?: boolean): Promise<ZulipChannelDto>;
    public spawnChannel(workspaceId: string, channelId: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<ZulipChannelDto>>;
    public spawnChannel(workspaceId: string, channelId: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<ZulipChannelDto>>;
    public spawnChannel(workspaceId: string, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling spawnChannel.');
        }
        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling spawnChannel.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/zulip/${encodeURIComponent(String(workspaceId))}/spawn/${encodeURIComponent(String(channelId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param workspaceId 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unfavorite(workspaceId: string, name: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    public unfavorite(workspaceId: string, name: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    public unfavorite(workspaceId: string, name: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    public unfavorite(workspaceId: string, name: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (workspaceId === null || workspaceId === undefined) {
            throw new Error('Required parameter workspaceId was null or undefined when calling unfavorite.');
        }
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling unfavorite.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/zulip/${encodeURIComponent(String(workspaceId))}/${encodeURIComponent(String(name))}/unfavorite`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param path 
     * @param previewPath 
     * @param contentType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadPreview(path?: string, previewPath?: string, contentType?: string, observe?: 'body', reportProgress?: boolean): Promise<UploadPolicy>;
    public uploadPreview(path?: string, previewPath?: string, contentType?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<UploadPolicy>>;
    public uploadPreview(path?: string, previewPath?: string, contentType?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<UploadPolicy>>;
    public uploadPreview(path?: string, previewPath?: string, contentType?: string, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (path !== undefined && path !== null) {
            queryParameters = queryParameters.set('path', <any>path);
        }
        if (previewPath !== undefined && previewPath !== null) {
            queryParameters = queryParameters.set('previewPath', <any>previewPath);
        }
        if (contentType !== undefined && contentType !== null) {
            queryParameters = queryParameters.set('contentType', <any>contentType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.post(`${this.basePath}/api/zulip/uploadPreview`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

}
